import React from 'react';
import PropTypes from 'prop-types';

const Section = ({ children }) => (
  <div className="c-membership-section">{children}</div>
);

Section.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Section;



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/components/Section.jsx